import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { DateRangePickerMobile } from '@/kit/DatePickers/DateRangePickerMobile';
import { OperationTypeSelect } from '@/components/TaxReport/OperationTypeSelect';
import { ActionMenu } from '@/components/TaxReport/ActionMenu';
import s from './index.module.scss';

export const FilterViewMobile = ({ params, onFilterChange }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.list}>
        <div className={s.scroll}>
          <PeriodSelect
            mobile
            range={params.range}
            onChange={range => onFilterChange('range', range)}
          />
          <DateRangePickerMobile
            range={params.range}
            setRange={range => onFilterChange('range', range)}
            maxDate={new Date()}
          />
          <OperationTypeSelect
            mobile
            selected={params.operation_types}
            onChange={types => onFilterChange('operation_types', types)}
          />
        </div>
        <div className={s.fade_right} />
      </div>
      <ActionMenu />
    </div>
  );
};
